import { StaticDataset } from '@/types/datasets.ts';

/** Capture edited inputs; the server inherits other pins and removes unused bindings. */
export function staticSelectionsForEdit(
  value: unknown,
  selected: Record<string, string> | null | undefined,
  sources: StaticDataset[],
): Record<string, string> | undefined {
  const ids = new Set<string>();
  function visit(node: unknown) {
    if (!node || typeof node !== 'object') return;
    if (Array.isArray(node)) {
      node.forEach(visit);
      return;
    }
    const record = node as Record<string, unknown>;
    if (record.data_input_type === 'static') {
      const config = record.config;
      if (config && typeof config === 'object' && 'static_dataset_id' in config) {
        if (typeof config.static_dataset_id === 'string') ids.add(config.static_dataset_id);
      }
      return;
    }
    Object.values(record).forEach(visit);
  }
  visit(value);
  const updates: Record<string, string> = {};
  for (const id of ids) {
    const revision =
      selected?.[id] ?? sources.find((source) => source.id === id)?.latest_ready_revision_id;
    if (!revision)
      throw new Error('This data source needs a ready revision before it can be selected.');
    updates[id] = revision;
  }
  return ids.size ? updates : undefined;
}
